import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { toCroppedImage } from '~/shared/utils/image'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ArticleCard extends BaseModel {
  static override constructorName = 'ArticleCard'

  id: number = 0
  name: string = ''
  slug: string = ''
  image: string = ''
  'preview_image': string = ''
  'published_at': string = ''
  'created_at': string = ''
  'author_name': string = ''

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data)

    const image = this.image || this.preview_image
    const previewImage = this.preview_image || this.image

    this.image = toCroppedImage(image)
    this.preview_image = toCroppedImage(previewImage)
  }

  get publicationDate(): string {
    return this.published_at || this.created_at
  }
}

registerModel(ArticleCard)
